export default __webpack_public_path__ + "static/media/header_shelf.7a3383c5.jpg";